export default {"src":"/_next/static/media/bze.4674b21c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};